export const PROPERTIES = [
  {
    id: 1,
    title: "Maison Lumière",
    location: "Le Marais, Paris",
    price: "€4,200 / mo",
    beds: 3,
    baths: 2,
    sqm: 142,
    tag: "Featured",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&q=80",
  },
  {
    id: 2,
    title: "Atelier Saint-Germain",
    location: "Saint-Germain, Paris",
    price: "€3,600 / mo",
    beds: 2,
    baths: 1,
    sqm: 98,
    tag: "New",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
  },
  {
    id: 3,
    title: "Penthouse Étoile",
    location: "Champs-Élysées, Paris",
    price: "€8,900 / mo",
    beds: 4,
    baths: 3,
    sqm: 210,
    tag: "Luxury",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=900&q=80",
  },
  {
    id: 4,
    title: "Loft Oberkampf",
    location: "Oberkampf, Paris",
    price: "€2,800 / mo",
    beds: 1,
    baths: 1,
    sqm: 74,
    tag: "Popular",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=80",
  },
  {
    id: 5,
    title: "Villa Montmartre",
    location: "Montmartre, Paris",
    price: "€5,500 / mo",
    beds: 3,
    baths: 2,
    sqm: 165,
    tag: "New",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=900&q=80",
  },
  {
    id: 6,
    title: "Résidence Bastille",
    location: "Bastille, Paris",
    price: "€3,100 / mo",
    beds: 2,
    baths: 2,
    sqm: 110,
    tag: "Featured",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=80",
  },
];